import { css } from 'styled-components';

export const ellipsisOverflow = css`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

/** @deprecated Use `ellipsisOverflow` instead */
export const elipsisOverflow = ellipsisOverflow;

export const lineClamp = (lines: number) => css`
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: ${lines};
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
`;
